import { RHProviderProfileComponent, ScoProviderProfileComponent } from "../components/ProviderProfile"
import { Constants } from "../constants/appConstants";
import ComponentHeader from "./ComponentHeader"
import { useAppContext } from '../Context';
import { useLocation } from 'react-router';

function ProviderProfile() {
  const location = useLocation();
  const { providerType: contextProviderType, reviewYear: contextReviewYear } = useAppContext();
  const providerType: string = location?.state?.providerType ?? contextProviderType;
  const reviewYear: number | undefined = location?.state?.reviewYear ?? contextReviewYear;
  const isSCOType = providerType === Constants.SCOKey;

  const items = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Provider Profile', path: '/provider' }
  ];

  return (
    <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
      <ComponentHeader
        breadcrumbs={items}
        providerType={providerType}
        reviewYear={reviewYear}
        hideProviderTypeDropdown
      />
      {isSCOType
        ? <ScoProviderProfileComponent reviewYear={reviewYear} />
        : <RHProviderProfileComponent reviewYear={reviewYear} />
      }
    </div>
  );
}

export default ProviderProfile